import { render, staticRenderFns } from "./faturamento.vue?vue&type=template&id=26e70e34"
import script from "./faturamento.vue?vue&type=script&lang=js"
export * from "./faturamento.vue?vue&type=script&lang=js"
import style0 from "./faturamento.vue?vue&type=style&index=0&id=26e70e34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports